import { Location } from "@angular/common";
import { Component, EventEmitter, OnDestroy, OnInit } from "@angular/core";
import { ObservedAuctionDTO } from "@shared/model/auction.model";
import { ApiService } from "@shared/services/api.service";
import { MqttService } from "@shared/services/mqtt/mqtt.service";
import { ClickarUtilsService } from "@shared/services/utils/clickar-utils.service";

@Component({
	selector: "app-live-full",
	templateUrl: "./live-full.component.html",
	styleUrl: "./live-full.component.scss",
	standalone: false
})
export class LiveFullComponent implements OnInit, OnDestroy {
	// private timeObservable: Subscription;
	serverTime: number; // timestamp
	leasysObservedAuctions: ObservedAuctionDTO[];
	observedAuctions: ObservedAuctionDTO[];
	// flagAnimation = false;
	destroyed = false;
	reconnectEmitter = new EventEmitter<number>();

	constructor(
		private mqttService: MqttService,
		public utils: ClickarUtilsService,
		private _location: Location,
		private apiService: ApiService
	) { }

	protected trimAuction = (auctions: ObservedAuctionDTO[], auction: ObservedAuctionDTO) => {
		const index = auctions.indexOf(auction);
		if (index !== -1) {
			auctions.splice(index, 1);
		}
	};

	ngOnInit() {
		/* 	this.timeObservable = interval(6e4)
				.pipe(startWith(0))
				.subscribe(() => { */
		this.apiService.getTimeUsingGET().subscribe(value => {
			this.serverTime = value;
		});
		/* }); */

		this.mqttService.connect(true).subscribe(() => {
			this.apiService
				.getObservedAuctionsLotsUsingGET()
				.subscribe(value => {
					value.sort((a, b) =>
						a.auctionDTO.endDate < b.auctionDTO.endDate
							? -1
							: a.auctionDTO.endDate > b.auctionDTO.endDate
								? 1
								: 0
					);
					this.observedAuctions = [];
					this.leasysObservedAuctions = [];
					for (const a of value) {
						this[a.auctionDTO.auctionType === "LEA" ? "leasysObservedAuctions" : "observedAuctions"].push(a);
					}
				});
		});

		this.mqttService.disconnected().subscribe(x => {
			console.log("mqtt disconnected");
			if (!this.destroyed) {
				console.log("mqtt reconnect");
				this.mqttService.connect().subscribe(() => {
					this.reconnectEmitter.emit(1);
				});
			}
		});
	}

	ngOnDestroy(): void {
		this.destroyed = true;
		this.mqttService.disconnect();
		// this.timeObservable.unsubscribe();
	}

	goBack() {
		this._location.back();
	}
}